"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var common = {
  black: '#000000',
  white: '#ffffff'
};
var _default = common;
exports["default"] = _default;